import produce from 'immer';

import { MarketStatus } from '@swf/generated/types/api/sports';
import type { MarketPollingData } from '@swf/sports/types/market';
import updateMarket from '@swf/sports/utils/updateMarket';

import { defaultState } from './defaultState';
import type { MatchFiltersApiSuccessResponse, MatchFiltersRequestedPayload } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: () => defaultState,
  matchFiltersRequested: (
    state: State,
    { polling = false, isPageChange = false }: MatchFiltersRequestedPayload = {}
  ): State => ({
    ...state,
    ...(isPageChange && {
      filters: {
        marketTypes: [],
        durations: []
      }
    }),
    loading: true,
    polling
  }),
  dataLoadedSuccessfully: (state: State, payload: MatchFiltersApiSuccessResponse): State => ({
    ...state,
    ...payload,
    firstLoadComplete: true,
    loading: false,
    polling: false,
    errorCode: undefined,
    hasPreloaded: true
  }),
  dataLoadFailed: (state: State, payload: string): State => ({
    ...state,
    firstLoadComplete: true,
    loading: false,
    polling: false,
    errorCode: payload,
    hasPreloaded: true
  }),
  marketsUpdated: (state: State, { data: marketUpdates, closed }: MarketPollingData) =>
    produce(state, (draft) => {
      Object.values(draft.markets).forEach((market) => {
        if (!market) return;

        if (closed.includes(market.marketId)) {
          market.marketStatus = MarketStatus.CLOSED;
          return;
        }

        const marketUpdate = marketUpdates[market.marketId];

        if (marketUpdate) updateMarket(market, marketUpdate);
      });

      return draft;
    })
};
